<template>
  <div class="attached-files">
    <div class="between gap-16 mb-20">
      <SearchForm
        class="attached-files__search"
        @form-submit="setSearch"
      />

      <span class="attached-files__count">Загружено файлов: {{ count }}</span>
    </div>

    <FileList
      :file-list="filteredFiles"
      :is-disabled="isDisabled"
      @delete-file="deleteFile"
      @drop-files="dropHandler"
    />
  </div>
</template>

<script>
import FileList from '@/components/page/files/FileList.vue'
import SearchForm from '@/components/page/input/SearchForm.vue'
import { getFileName } from '@/utils/file'

export default {
  name: 'AttachedFiles',
  components: { SearchForm, FileList },
  props: {
    fileList: {
      type: [Array, FileList],
      required: true
    },
    isDisabled: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    search: ''
  }),
  computed: {
    count () {
      return this.fileList?.length || 0
    },
    filteredFiles () {
      const search = this.search.toLowerCase().trim()
      if (!search) return this.mappedFiles

      return this.mappedFiles.filter(file => getFileName(file).toLowerCase().includes(search))
    },
    mappedFiles () {
      return this.fileList.map((file, i) => {
        file.idx = i
        return file
      })
    }
  },
  methods: {
    deleteFile (file) {
      this.$emit('delete-file', file)
    },
    setSearch (value = '') {
      this.search = value
    },
    dropHandler (result) {
      this.$emit('drop-files', result)
    }
  }
}
</script>

<style lang="scss">
.attached-files {
  max-width: calc(470px * 2 + 70px);
  padding: 20px 40px 20px 16px;
  background-color: #E4E7F7;

  &__search {
    max-width: 420px;
  }

  &__count {
    align-self: flex-end;
    padding-right: 10px;
    font-weight: 400;
    font-size: 14px;
    line-height: 17px;
    white-space: nowrap;
    color: $font_color_third;
  }

  .smooth-dnd-container.vertical > .smooth-dnd-draggable-wrapper {
    overflow: initial;
  }

  .grabbing {
    cursor: grabbing;
  }
}
</style>
